"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrganizationInvitationErrorSchema = exports.OrganizationInvitationErrorCodes = void 0;
const z = __importStar(require("zod"));
const base_error_interface_1 = require("./base-error.interface");
exports.OrganizationInvitationErrorCodes = {
    // Acceptance failures
    NOT_FOUND: 'INVITATION_NOT_FOUND',
    EXPIRED: 'INVITATION_EXPIRED',
    REVOKED: 'INVITATION_REVOKED',
    ALREADY_ACCEPTED: 'INVITATION_ALREADY_ACCEPTED',
    EMAIL_MISMATCH: 'INVITATION_EMAIL_MISMATCH',
    SSO_PROVIDER_MISMATCH: 'SSO_PROVIDER_MISMATCH',
    // Invitee already belongs to an organization at acceptance time. Distinct from the
    // creation-time CONFLICT_MEMBER_OF_OTHER_ORG: that one is shown to the inviting admin
    // ("can't invite this person"); this one is shown to the invitee ("you can't accept").
    // The invitation is also marked terminal when this fires so the admin's view reflects
    // reality rather than showing a perpetually pending invite.
    INVITEE_ALREADY_IN_ORGANIZATION: 'INVITEE_ALREADY_IN_ORGANIZATION',
    // Conflicts at invitation creation time
    CONFLICT_ALREADY_MEMBER: 'INVITATION_CONFLICT_ALREADY_MEMBER',
    CONFLICT_MEMBER_OF_OTHER_ORG: 'INVITATION_CONFLICT_MEMBER_OF_OTHER_ORG',
    CONFLICT_PENDING_TO_OTHER_ORG: 'INVITATION_CONFLICT_PENDING_TO_OTHER_ORG',
    // Resend rate limit
    RESEND_TOO_FREQUENT: 'INVITATION_RESEND_TOO_FREQUENT',
};
exports.OrganizationInvitationErrorSchema = base_error_interface_1.BaseErrorSchema.extend({
    code: z.enum([
        exports.OrganizationInvitationErrorCodes.NOT_FOUND,
        exports.OrganizationInvitationErrorCodes.EXPIRED,
        exports.OrganizationInvitationErrorCodes.REVOKED,
        exports.OrganizationInvitationErrorCodes.ALREADY_ACCEPTED,
        exports.OrganizationInvitationErrorCodes.EMAIL_MISMATCH,
        exports.OrganizationInvitationErrorCodes.SSO_PROVIDER_MISMATCH,
        exports.OrganizationInvitationErrorCodes.INVITEE_ALREADY_IN_ORGANIZATION,
        exports.OrganizationInvitationErrorCodes.CONFLICT_ALREADY_MEMBER,
        exports.OrganizationInvitationErrorCodes.CONFLICT_MEMBER_OF_OTHER_ORG,
        exports.OrganizationInvitationErrorCodes.CONFLICT_PENDING_TO_OTHER_ORG,
        exports.OrganizationInvitationErrorCodes.RESEND_TOO_FREQUENT,
    ]),
    description: z.string().min(1),
});
